import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { Router, RouterLink, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from '../auth/services/auth.service';
import { LucideAngularModule } from 'lucide-angular';
import { DropdownMenuComponent } from '../../shared/components/dropdown-menu/dropdown-menu.component';
import { AvatarComponent } from '../../shared/components/avatar/avatar.component';
import { AvatarImageComponent } from '../../shared/components/avatar/components/avatar-image/avatar-image.component';
import { AvatarFallbackComponent } from '../../shared/components/avatar/components/avatar-fallback/avatar-fallback.component';
import { DropdownMenuItemComponent } from '../../shared/components/dropdown-menu/components/dropdown-menu-item/dropdown-menu-item.component';
import { UpperCasePipe } from '@angular/common';
import { ThemeService } from '../auth/services/theme.service';
import { ClientService } from '../../shared/services/client.service';


@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    RouterLink,
    RouterOutlet,
    LucideAngularModule,
    DropdownMenuComponent,
    DropdownMenuItemComponent,
    AvatarComponent,
    AvatarImageComponent,
    AvatarFallbackComponent,
    UpperCasePipe
  ],
  templateUrl: './layout.component.html',
})
export class LayoutComponent implements OnInit{
  private router = inject(Router);
  private authService = inject(AuthService);
  private themeService = inject(ThemeService);
  private clientService = inject(ClientService);
  user = this.authService.userName;
  logo = signal<string>(this.themeService.getLogo());


  ngOnInit() {
    this.updateUI();

    this.clientService.setDadosCliente().subscribe({
      next: () => {
        this.updateUI();
      },
      error: (error) => {
        console.error('Erro ao carregar dados do cliente', error);
      }
    });
  }

  private navigationEvents = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map((event) => (event as NavigationEnd).urlAfterRedirects),
    startWith(this.router.url),
  );

  private currentUrl = toSignal(this.navigationEvents, { initialValue: this.router.url });

  breadcrumbs = computed(() => {
    const url = this.currentUrl();
    const segments = url.split('/').filter((s) => s && s !== '');
    const crumbs: { label: string; path: string; isRegistration: boolean; isSettings: boolean }[] =
      [];

    let accumulatedPath = '';

    const labels: Record<string, string> = {
      modules: 'Painel',
      users: 'Gestão de Usuários',
      handover: 'Passagem de Plantão',
      assistant: 'Assistente Digital',
      profiles: 'Gestão de Perfis de Acesso',
      'profile-builder': 'Construtor de Perfis',
      recovery: 'Recuperação de Senha',
      login: 'Login',
    };

    segments.forEach((segment) => {
      accumulatedPath += `/${segment}`;
      if (labels[segment]) {
        crumbs.push({
          label: labels[segment],
          path: accumulatedPath,
          isRegistration: segment === 'users',
          isSettings: segment === 'profiles',
        });
      }
    });

    return crumbs;
  });

  pageTitle = computed(() => {
    const url = this.currentUrl();
    if (url === '/modules') return 'Módulos Disponíveis';
    if (url === '/handover') return 'Passagem de Plantão';
    if (url === '/users') return 'Gestão de Usuários';
    if (url === '/profiles') return 'Gestão de Perfis de Acesso';
    return '';
  });

  logout() {
    this.authService.logout();
  }

  private updateUI() {
    this.themeService.applyTheme();
    this.logo.set(this.themeService.getLogo());
  }
}